Modal = require './modal.coffee'

class Order
	constructor: (data) ->
		data.action = 'order'

		@modal = new Modal data

	submit: =>
		@modal.modal()
		yaCounter35657265.reachGoal 'order_service' unless _.isUndefined yaCounter35657265

$.fn.extend
	order: (options) ->
		for order in @
			$order = $ order
			new Order $order

$ ->
	$orders = $ '[data-order]'
	$orders.order()

module.exports = Order


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/order.coffee
 **/